module.exports = __webpack_public_path__ + "static/media/CertificateVibalLogoEdited.79494ea4.png";